export default __webpack_public_path__ + "static/media/sv5_en_alph_a2.de9f91d7.mp3";